module.exports = __webpack_public_path__ + "group-14.svg?a00b109e5074ba717ee283ca2227d725";